import Marquee3k from "marquee3000";

export const ticker = function (el) {
    Marquee3k.init();
};
